import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Footer from "../../../components/Footer";
import useDoctorDetails from "./useDoctorDetails";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import bgImage from "assets/images/bg_doctor.jpg";
import {COLOR_SECONDARY} from "../../../config";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import React, {useEffect, useState} from "react";
import Icon from "@mui/material/Icon";
import {Tab, Tabs} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import breakpoints from "../../../assets/theme/base/breakpoints";

const DoctorDetails = () => {

    const {id, isLoggedIn, doctor, isLoading, tabsOrientation, tabValue, handleSetTabValue, renderTabContent, renderMainContent} = useDoctorDetails();

    if(isLoggedIn){
        return (
            <DashboardLayout>
                <DashboardNavbar />
                {
                    renderMainContent()
                }
                <Footer />
            </DashboardLayout>
        );
    } else {
        return <MDBox p={2}>
            {renderMainContent()}
        </MDBox>
    }

};

export default DoctorDetails;
